export class FormsApiConfigurationError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'FormsApiConfigurationError'
  }
}

export function getFormsApiConfig() {
  const inquiryUrl = import.meta.env.VITE_INQUIRY_API_URL?.trim()

  if (!inquiryUrl) {
    throw new FormsApiConfigurationError(
      'VITE_INQUIRY_API_URL is missing. Add the shared Azure forms endpoint to the frontend environment.',
    )
  }

  let parsedUrl: URL
  try {
    parsedUrl = new URL(inquiryUrl)
  } catch {
    throw new FormsApiConfigurationError('VITE_INQUIRY_API_URL must be an absolute URL.')
  }

  if (import.meta.env.PROD && parsedUrl.protocol !== 'https:') {
    throw new FormsApiConfigurationError('The production forms endpoint must use HTTPS.')
  }

  if (parsedUrl.pathname !== '/api/send-inquiry' || parsedUrl.search || parsedUrl.hash) {
    throw new FormsApiConfigurationError(
      'VITE_INQUIRY_API_URL must point to the shared /api/send-inquiry endpoint.',
    )
  }

  return { inquiryUrl: parsedUrl.toString() }
}
